<template>
  <form class="shadow postcard-comp" :class="{'postcard-comp--event-edit': (postcard_info.category === 'Event' || getCategory() === 'Event') && !postcard_info.readOnly}" action="">
    <div class="postcard-wrapper">
      <div v-if="!attachmentShown" class="postcard__front">
        <div class="postcard__right">
          <div class="postcard__date">
            <ul>
              <li>
                {{ getDateString(postcard_info.date) }}
              </li>
              <li>
                <v-img v-if="
                  postcard_info.readOnly &&
                  ['PC', 'Phone', 'Mailbox'].includes(postcard_info.sentFrom)
                " :alt="'Created from ' + postcard_info.sentFrom" contain :src="require(`../../../client-shared/img/stamp_${postcard_info.sentFrom.toLowerCase()}.svg`)
                  " class="date__img date__img--stamp" />
                <v-img alt="hubbel image"
                       contain
                       :src="
                       Number.isFinite(postcard_info.id)
                       ? require(`../../../client-shared/img/stamp${Number(postcard_info.id)  % 4}.jpg`)
                       : require ('../../../client-shared/img/hubbel_logo.svg')"
                       class="date__img date__img--white-stamp date__img--stamp-image" />
              </li>
            </ul>
          </div>
          <div v-if="
            loggedInUser != null &&
            loggedInUser.level_of_user !== 'normal' &&
            !postcard_info.readOnly
          " class="postcard__moderation">
            <v-btn elevation="1" outlined class="approvePost" @click="approve(postcard_info)">freischalten</v-btn>
            <v-btn elevation="1" outlined class="deletePost" @click="hide(postcard_info)">löschen</v-btn>
          </div>
          <div v-if="
            loggedInUser != null &&
            loggedInUser.level_of_user !== 'normal' &&
            postcard_info.readOnly &&
            postcard_info.approved
          " class="postcard__moderation">
            <v-btn elevation="1" outlined class="editPost" @click="makePostcardEditable()">jetzt prüfen</v-btn>
          </div>
          <div class="postcard__sender">
            <ul>
              <li>Absender*in</li>
              <li>
                <div v-if="
                  postcard_info.readOnly ||
                  postcard_info.topicFixed ||
                  postcard_info.sentFrom !== 'Mailbox'
                ">
                  <!-- TODO when someone writes a postcard, the postcard already has to know if the user is verified to show this here -->
                  <b :class="'verified--' + postcard_info.sender_verified">{{ postcard_info.sender }}&nbsp;<v-img
                      v-if="postcard_info.sender_verified" class="verified-icon"
                      src="../../../client-shared/img/verification_hubbel_v01.svg" alt="(verified)" width="18"
                      tabindex="1" />
                  </b>
                </div>
                <div v-else class="selectQuestion">
                  <v-text-field v-model="senderName" dense clearable />
                </div>
              </li>
            </ul>
          </div>
          <div class="postcard__subject">
            <ul>
              <br />
              <li>Thema:</li>
              <li>
                <div v-if="postcard_info.readOnly || postcard_info.topicFixed">
                  <router-link :to="`/Forum/${postcard_info.subject}`" class="subject__link">
                    <b>{{ postcard_info.subject }}</b>
                  </router-link>
                </div>
                <div v-else class="selectQuestion">
                  <select v-model="selectedTopic">
                    <option v-for="topic in possibleTopics" :key="topic.topic_id" :value="topic.topic_id"
                      :title="topic.name">
                      {{
                        topic.name.substr(0, 15) + (topic.name.length > 15 ? "..." : "")
                        /*TODO: A line-break would be preferred here*/
                      }}
                    </option>
                  </select>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="postcard__vertical-line"/>
        <div class="postcard__left">
           <div v-if="
            loggedInUser != null &&
            (loggedInUser.level_of_user === 'admin' ||
            loggedInUser.level_of_user === 'moderator')"
            class="answer-pin-icon"
            @click="pinAnswerElement($event)">
            <v-icon v-if="!postcard_info.isPinned && postcard_info.isAnswer && showPins"> $pin </v-icon>
            <v-icon v-if="postcard_info.isPinned && postcard_info.isAnswer && showPins"> $pinFilled </v-icon>
          </div>
          <div v-else
            class="answer-pinFilled-icon">
            <v-icon v-if="postcard_info.isAnswer && showPins && postcard_info.isPinned"> $pinFilled </v-icon>
           </div>

          <div v-if="postcard_info.readOnly || postcard_info.topicFixed">
            <label v-if="postcard_info.category === 'Information'"
              class="postcard__category postcard__category--information">Information
            </label>
            <label v-if="postcard_info.category === 'Question'"
              class="postcard__category postcard__category--question">Frage
            </label>
            <label v-if="postcard_info.category === 'Event'"
              class="postcard__category postcard__category--event">Veranstaltung
            </label>
            <label v-if="postcard_info.category === 'Answer'"
              class="postcard__category postcard__category--answer">Antwort
            </label>
          </div>
          <div v-else class="selectInformation" :class="'selectInformation--' + category">
            <select v-model="category">
              <option value="Information">Information</option>
              <option value="Question">Frage</option>
              <option value="Event">Event</option>
              <option value="Answer">Antwort</option>
            </select>
          </div>

          <br />
          <div>
            <p v-if="postcard_info.readOnly" class="postcard__message font-regular" :class="{
              'postcard__message--moderationAdjustment':
                loggedInUser != null && loggedInUser.level_of_user !== 'normal',
            }">
            <span v-if="postcard_info.approved || (loggedInUser != null && postcard_info.sender === fullName(loggedInUser))">
              <template v-if="postcard_info.category === 'Event' || getCategory() === 'Event'">
                <div class="row-flex">
                  <p class="text-left">Titel:&nbsp;</p>
                  <p><b>{{ postcard_info.eventTitle }}</b></p>
                </div>
                <div class="row-flex">
                  <p class="text-left">Termin:&nbsp;</p>
                  <p><b>{{ formatEventDate(postcard_info) }}</b></p>
                </div>
                <div class="row-flex">
                  <p class="text-left">Ort:&nbsp;</p>
                  <p><b>{{ postcard_info.eventLocation }}</b></p>
                </div>
              </template>
              {{ postcard_info.text }}
            </span>
            <span v-else class="dummyText">
              {{ dummyText }}
            </span>
            </p>
            <div v-else>
              <div v-if="postcard_info.category === 'Event' || getCategory() === 'Event'">
                <p class="text-left">Titel</p>
                <input v-model="eventTitle" id="title" type="text" placeholder="Titel" class="postcard__input postcard__input--editable"
                       maxlength="80"/>
                <div class="row-flex" style="flex-direction: column !important;">
                  <div class="mr-2">
                    <p class="text-left">Beginn</p>
                    <div>
                      <input ref="startDateInput" v-model="eventStartDate" type="date" @click="openNativePicker('startDate')" @focus="openNativePicker('startDate')" :min="startMinDate" style="max-width: 195px;" class="postcard__input postcard__input--editable postcard__input--compact"/>
                      <input ref="startTimeInput" v-model="eventStartTime" type="time"  @click="openNativePicker('startTime')" @focus="openNativePicker('startTime')" style="max-width: 187px; margin-left: 5px;" step="60" class="postcard__input postcard__input--editable postcard__input--compact"/>
                    </div>
                  </div>
                  <div></div>
                  <div>
                    <p class="text-left">Ende</p>
                    <div>
                      <input ref="endDateInput" v-model="eventEndDate" type="date" @click="openNativePicker('endDate')" @focus="openNativePicker('endDate')" style="max-width: 195px;" :min="endMinDate" class="postcard__input postcard__input--editable postcard__input--compact"/>
                      <input ref="endTimeInput" v-model="eventEndTime" type="time" @click="openNativePicker('endTime')" @focus="openNativePicker('endTime')" style="max-width: 187px; margin-left: 5px;" step="60" :min="endMinTimeIfSameDay" class="postcard__input postcard__input--editable postcard__input--compact"/>
                    </div>
                  </div>
                </div>
                <p class="text-left">Ort</p>
                <input v-model="eventLocation" id="location" type="text" placeholder="Ort" class="postcard__input postcard__input--editable" maxlength="45"/>
                <p></p>
              </div>
              <textarea v-model="writtenText" class="postcard__message postcard__message--editable font-regular"
                name="message" maxlength="500" rows="12" cols="40" :placeholder="postcard_info.text.length > 0
                  ? postcard_info.text
                  : 'Inhalt (maximal 500 Zeichen)'
                  " />
              <!-- <v-icon class="message__paper-clip" @click="openInput()"> $paperclip </v-icon> -->
              <span class="message__text-length">{{ writtenText.length }}/500</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="attachmentShown" class="postcard__back">
        <Attachment :attachments="attachments" :postcard_id="postcard_info.id" :read-only="postcard_info.readOnly"
          @deleteAttachment="deleteAttachment" @openInput="openInput()" />
      </div>
    </div>
    <Button v-if="!postcard_info.readOnly || (attachments.length > 0 && postcard_info.approved)" id="attachmentSwitcher"
      :is-anhang="true"
      :icon="attachmentShown ? 'postcard' : 'paperclip'"
      :label_text="attachmentShown
        ? 'Postkarte anzeigen'
        : attachments.length === 0
          ? 'Anhang hinzufügen'
          : attachments.length + (attachments.length === 1 ? ' Anhang' : ' Anhänge')
        " class="postcard__attachment-switcher" @click.native="toggleAttachment($event)" />
    <input v-if="!postcard_info.readOnly" id="fileChooser" type="file" class="fileChooser" accept="image/*,.pdf"
      multiple @change="uploadAttachments()" />
  </form>
</template>

<script>
import Button from "@/components/Button";
import Attachment from "@/components/Attachment";
import { baseURL } from "@/services/api";
import Api from "../services/api";

export default {
  name: "PostCard",
  components: {
    Attachment,
    Button,
  },
  props: {
    postcard_info: { type: Object },
    loggedInUser: { type: Object },
    noPin: {
      type: Boolean,
      required: false,
    },
    pinned: {
      type: Boolean,
      required: false,
      default: false,
    },
    showPins: {
      type: Boolean,
      default: true,
    },

  },
  data: () => ({
    writtenText: null,
    eventTitle: null,
    eventLocation: null,
    eventStartDate: null, // "YYYY-MM-DD"
    eventStartTime: null, // "HH:mm"
    eventEndDate: null,
    eventEndTime: null,
    eventEndDateTime: null,
    eventStartDateTime: null,
    category: null,
    selectedTopic: null,
    senderName: null,
    possibleTopics: [],
    attachmentShown: false,
    attachments: [],
    localPinned: false,
  }),
  computed: {
    isEditingExistingEvent() {
      const pc = this.postcard_info || {};
      return Boolean(pc.id && pc.eventStartDateTime);
    },

    startMinDate() {
      // beim Neuanlegen: heute; beim Editieren: min entfernen
      return this.isEditingExistingEvent ? null : this.todayDate;
    },

    dummyText() {
      return "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.";
    },
    todayDate() {
      const d = new Date();
      // lokales Datum (keine UTC-Verschiebung)
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },

    endMinDate() {
      // Ende darf frühestens Startdatum sein (und Startdatum ist sowieso >= heute)
      return this.eventStartDate || this.todayDate;
    },

    endMinTimeIfSameDay() {
      if (!this.eventStartDate || !this.eventStartTime) return null;
      if (this.eventEndDate !== this.eventStartDate) return null;

      const s = this.parseLocalDateTime(`${this.eventStartDate}T${this.eventStartTime}`);
      if (!s) return null;
      s.setMinutes(s.getMinutes() + 1);
      return this.toLocalIsoNoTZ(s).slice(11, 16);
    },
  },
  watch: {
    writtenText: function (val, oldVal) {
      if (val !== oldVal) this.$emit("writtenTextChanged", val);
    },
    eventTitle: function (val, oldVal) {
      if (val !== oldVal) this.$emit("eventTitleChanged", val);
    },
    eventLocation: function (val, oldVal) {
      if (val !== oldVal) this.$emit("eventLocationChanged", val);
    },
    eventStartDate() {
      if (!this.isEditingExistingEvent) {
        this.ensureStartDateNotBeforeToday();
      }
      this.ensureEndDateNotBeforeStartDate();
      this.syncStartDateTime();
    },
    eventEndDate() {
      this.ensureEndDateNotBeforeStartDate();
      this.syncEndDateTime(); // optional: wenn Endzeit schon da ist, direkt updaten
    },

    eventStartTime() { this.syncStartDateTime(); },
    eventEndTime()   { this.syncEndDateTime(); },


    /*eventStartDateTime(val, oldVal) {
      if (!val) return
      if (this.eventEndDateTime && new Date(this.eventEndDateTime) <= new Date(val)) {
        const newEnd = new Date(val)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
      if (val !== oldVal) this.$emit("eventStartDateTimeChanged", this.eventStartDateTime)
    },
    eventEndDateTime(val, oldVal) {
      if (!val) return
      if (this.eventStartDateTime && new Date(val) <= new Date(this.eventStartDateTime)) {
        const newEnd = new Date(this.eventStartDateTime)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
      if (val !== oldVal) this.$emit("eventEndDateTimeChanged", this.eventEndDateTime)
    },*/
  },
  created() {
    this.localPinned = this.pinned;
    this.attachments = this.postcard_info.attachments
      ? this.renderAttachments(this.postcard_info.attachments)
      : [];
    this.writtenText = this.postcard_info.text;
    this.eventTitle = this.postcard_info.eventTitle;
    this.eventLocation = this.postcard_info.eventLocation;
    this.eventStartDateTime = this.postcard_info.eventStartDateTime;
    this.eventEndDateTime = this.postcard_info.eventEndDateTime;
    this.splitDateTimeToFields();
    this.category = this.postcard_info.category;
    this.senderName = this.postcard_info.sender_name_mailbox;

    this.possibleTopics = this.postcard_info.allTopicNames || [];
    this.selectedTopic =
      this.possibleTopics.find((elem) => elem.name === this.postcard_info.subject)?.topic_id || 0;
  },
  methods: {
    pinAnswerElement(event){
      event.stopPropagation();
      if(this.postcard_info.id){
        Api.setAnswerPinned(this.postcard_info.id).then((res) => {
          this.localPinned = res.data;
          this.$set(this.postcard_info, 'isPinned', res.data);
        });
      }
    },


    openNativePicker(which) {
      const map = {
        startDate: "startDateInput",
        startTime: "startTimeInput",
        endDate: "endDateInput",
        endTime: "endTimeInput",
      };

      const refName = map[which];
      const el = this.$refs[refName];
      if (!el) return;

      // Chrome/Edge: öffnet den nativen Picker direkt
      if (typeof el.showPicker === "function") {
        el.showPicker();
        return;
      }

      // Fallback (Safari/Firefox): zumindest fokussieren
      el.focus();
    },

    ensureStartDateNotBeforeToday() {
      if (!this.eventStartDate) return;
      if (this.eventStartDate < this.todayDate) {
        this.eventStartDate = this.todayDate;

        // optional: wenn du willst, dass Ende direkt mitgezogen wird:
        this.ensureEndDateNotBeforeStartDate();
      }
    },
    ensureEndDateNotBeforeStartDate() {
      if (!this.eventStartDate || !this.eventEndDate) return;

      // string-compare geht bei YYYY-MM-DD korrekt
      if (this.eventEndDate < this.eventStartDate) {
        // Variante A (streng): sofort auf Startdatum setzen
        this.eventEndDate = this.eventStartDate;

        // wenn Ende-Uhrzeit existiert UND gleicher Tag → min time erzwingen
        if (this.eventEndTime && this.eventStartTime) {
          const minTime = this.endMinTimeIfSameDay; // "HH:mm" oder null
          if (minTime && this.eventEndTime < minTime) {
            this.eventEndTime = minTime;
          }
        }
      }
    },

    syncStartDateTime() {
      const combined = this.combineDateTime(this.eventStartDate, this.eventStartTime);
      if (combined === this.eventStartDateTime) return; // wichtig!
      this.eventStartDateTime = combined;

      this.ensureEndAfterStart();
      this.$emit("eventStartDateTimeChanged", this.eventStartDateTime);
    },

    syncEndDateTime() {
      const combined = this.combineDateTime(this.eventEndDate, this.eventEndTime);
      if (combined === this.eventEndDateTime) return; // wichtig!
      this.eventEndDateTime = combined;

      this.ensureEndAfterStart();
      this.$emit("eventEndDateTimeChanged", this.eventEndDateTime);
    },

    parseLocalDateTime(s) {
      if (!s) return null;
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
      if (!m) return null;
      const [_, Y, Mo, D, H, Mi] = m;
      return new Date(+Y, +Mo - 1, +D, +H, +Mi, 0, 0);
    },

    ensureEndAfterStart() {
      if (!this.eventStartDateTime || !this.eventEndDateTime) return;

      const s = this.parseLocalDateTime(this.eventStartDateTime);
      const e = this.parseLocalDateTime(this.eventEndDateTime);
      if (!s || !e) return;

      if (e <= s) {
        const newEnd = new Date(s);
        newEnd.setMinutes(newEnd.getMinutes() + 1);
        const iso = this.toLocalIsoNoTZ(newEnd);

        // setze End-Datetime + UI Felder konsistent
        this.eventEndDateTime = iso;
        this.eventEndDate = iso.slice(0, 10);
        this.eventEndTime = iso.slice(11, 16);
      }
    },


    splitDateTimeToFields() {
      const split = (dt) => {
        if (!dt) return { date: null, time: null };

        // sorgt dafür, dass wir wirklich "YYYY-MM-DDTHH:mm" haben
        const norm = this.toLocalIsoNoTZ(dt);
        if (!norm) return { date: null, time: null };

        return {
          date: norm.slice(0, 10),   // "YYYY-MM-DD"
          time: norm.slice(11, 16),  // "HH:mm"
        };
      };

      const s = split(this.eventStartDateTime);
      this.eventStartDate = s.date;
      this.eventStartTime = s.time;

      const e = split(this.eventEndDateTime);
      this.eventEndDate = e.date;
      this.eventEndTime = e.time;
    },

    combineDateTime(date, time) {
      if (!date || !time) return null;
      // exakt das Format, das <input datetime-local> und viele Backends erwarten:
      return `${date}T${time}`;
    },


    formatEventDate(pc) {
      if (!pc || !pc.eventStartDateTime) return "";

      const s = new Date(pc.eventStartDateTime);
      const e = pc.eventEndDateTime ? new Date(pc.eventEndDateTime) : null;

      const pad = n => String(n).padStart(2, "0");
      const fmtDate = d => `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${String(d.getFullYear()).slice(2)}`;
      const fmtTime = d => `${pad(d.getHours())}:${pad(d.getMinutes())}`;

      const startDate = fmtDate(s);
      const startTime = fmtTime(s);

      if (!e || isNaN(e.getTime())) {
        // kein Enddatum → nur Start anzeigen
        return `${startDate}, ${startTime}`;
      }

      const endDate = fmtDate(e);
      const endTime = fmtTime(e);

      const isSameDay =
        s.getFullYear() === e.getFullYear() &&
        s.getMonth() === e.getMonth() &&
        s.getDate() === e.getDate();

      //Eintägig → Datum einmal, Zeiten Start–Ende
      if (isSameDay) {
        return `${startDate}, ${startTime} – ${endTime}`;
      }

      //Mehrtägig → Datum + Zeit beides anzeigen
      return `${startDate}, ${startTime} – ${endDate}, ${endTime}`;
    },

    toLocalIsoNoTZ(value) {
      // gibt "YYYY-MM-DDTHH:mm" zurück (ohne Sekunden/Timezone)
      if (!value) return null
      if (typeof value === 'string') {
        const re = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/
        if (re.test(value)) return value.slice(0, 16)
        const d = new Date(value)
        if (!isNaN(d.getTime())) return this.toLocalIsoNoTZ(d)
        return null
      }
      const d = value instanceof Date ? value : new Date(value)
      if (isNaN(d.getTime())) return null
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
    },

    onStartChange() {
      if (this.eventStartDateTime && this.eventEndDateTime && new Date(this.eventEndDateTime) <= new Date(this.eventStartDateTime)) {
        const newEnd = new Date(this.eventStartDateTime)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
    },

    onEndChange() {
      if (this.eventStartDateTime && this.eventEndDateTime && new Date(this.eventEndDateTime) <= new Date(this.eventStartDateTime)) {
        const newEnd = new Date(this.eventStartDateTime)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
    },

    formatDateTime(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(d);
    },
    makePostcardEditable() {
      this.postcard_info.readOnly = false;
    },
    approve(postcard) {
      this.$confirm({
        title: "Freischalten?",
        message: "Soll die Postkarte endgültig freigeschaltet werden?",
        button: {
          no: "Nein, abbrechen!",
          yes: "Ja, freischalten!",
        },
        callback: (confirm) => {
          if (confirm) {
            postcard.text = this.getText();
            postcard.eventTitle = this.getEventTitle();
            postcard.eventLocation = this.getEventLocation();
            postcard.eventStartDateTime = this.getEventStartDateTime();
            postcard.eventEndDateTime = this.getEventEndDateTime();
            postcard.category = this.getCategory();
            postcard.topic_id = this.getSelectedTopic();
            postcard.sender_name = this.getSenderName();
            postcard.attachments = this.attachments;
            //console.log("approve postcard:", postcard);
            //console.log("PostCard this.attachments:", this.attachments);
            //console.log("vor API:", JSON.stringify(postcard.attachments));

            Api.updateAndApprovePostcard(postcard).then((res) => {
              if (res.status === 200) this.$router.go(0); // Refreshes site if approval was successful
            });
          }
        },
      });
    },
    hide(postcard) {
      this.$confirm({
        title: "Löschen?",
        message: "Soll die Postkarte endgültig gelöscht werden?",
        button: {
          no: "Nein, abbrechen!",
          yes: "Ja, löschen!",
        },
        callback: (confirm) => {
          if (confirm) {
            Api.hidePostcard(postcard).then((res) => {
              if (res.status === 200) this.$router.go(0); // Refreshes site if approval was successful
            });
          }
        },
      });
    },
    fullName(loggedInUser) {
      return loggedInUser.first_name + " " + loggedInUser.last_name;
    },
    getText() {
      return this.writtenText || "empty";
    },
    getEventTitle() {
      return this.eventTitle || null;
    },
    getEventLocation() {
      return this.eventLocation || null;
    },
    getEventStartDateTime() {
      return this.eventStartDateTime || null;
    },
    getEventEndDateTime() {
      return this.eventEndDateTime || null;
    },
    getCategory() {
      return this.category || false;
    },
    getSelectedTopic() {
      return this.selectedTopic || "";
    },
    getSenderName() {
      return this.senderName || "";
    },
    getDateString(cardDate) {
      const date = new Date(cardDate.replace(/\s/, "T") + "Z"); // https://stackoverflow.com/questions/21883699/safari-javascript-date-nan-issue-yyyy-mm-dd-hhmmss
      let dateString;

      dateString =
        ("0" + date.getDate()).slice(-2) +
        "." +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "." +
        date.getFullYear();

      return dateString;
    },
    getAttachments() {
      return this.attachments;
    },
    renderAttachments(attachments) {
      const att = [];
      attachments.forEach((attach) => {
        att.push({
          name: attach.name,
          type: attach.static_file_path.split(".").pop(),
          src: baseURL + "public/" + attach.static_file_path,
        });
      });
      return att;
    },
    pushRenderedAttachments(attachments) {
      this.attachments = attachments;
    },
    openInput() {
      document.getElementById("fileChooser").click();
    },
    uploadAttachments() {
      let fileList = document.getElementById("fileChooser").files;
      const attachments = this.attachments;

      if (!fileList) return;

      for (let i = 0; i < fileList.length; i++) {
        //const serverUrl = uploadToServer(fileList[i]);

        const fileReader = new FileReader();
        fileReader.readAsDataURL(fileList[i]);
        fileReader.addEventListener("load", function () {
          attachments.push({
            name: fileList[i].name,
            type: fileList[i].type.split("/")[1],
            //src: serverUrl
            src: this.result,
          });
        });
      }
      this.attachmentsVisualFeedback();
    },

    deleteAttachment(index) {
      this.attachments.splice(index, 1);
    },

    toggleAttachment(event) {
      event.stopPropagation();
      this.attachmentShown = !this.attachmentShown;
      if (
        this.attachmentShown &&
        this.attachments.length > 0 &&
        this.postcard_info.id !== undefined &&
        this.postcard_info.id !== null &&
        typeof this.postcard_info.id !== "undefined"
      ) {
        window._paq.push([
          "trackEvent",
          "Attachments",
          "Attachments Click",
          "Attachment Section of Postcard " + this.postcard_info.id + " selected",
        ]);
      }
    },

    attachmentsVisualFeedback() {
      const switcher = document.getElementById("attachmentSwitcher");
      const initialColor = switcher.style.backgroundColor;
      const hoverColor = "#c5e388"; //TODO make class

      switcher.style.backgroundColor = hoverColor;

      setTimeout(() => {
        switcher.style.backgroundColor = initialColor;
      }, 200);
      setTimeout(() => {
        switcher.style.backgroundColor = hoverColor;
      }, 400);
      setTimeout(() => {
        switcher.style.backgroundColor = initialColor;
      }, 600);
    },
  },
};
</script>
